import React from "react";

const Pagination = ({ currentPage, totalPages, totalRecords, onPageChange }) => {
  const pageCount = Math.max(totalPages, 1);
  const pageArray = Array.from({ length: pageCount }, (_, index) => index + 1);

  const handlePrevious = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < pageCount) onPageChange(currentPage + 1);
  };

  return (
    <div className="customTable__footer">
      <div className="customTable__left">
        <div className="customTable__totalTransactions">
          <p>
            Total Records: <span>{totalRecords}</span>
          </p>
        </div>
      </div>
      <div className="customTable__right">
        <div className="customTable__top">
          <div className="customTable__totalPages">
            <p>
              Page
              <select
                className="form-control selectArrow"
                value={currentPage}
                onChange={(e) => onPageChange(Number(e.target.value))}
              >
                {pageArray.map((value) => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
              </select>
              of
              <span>{pageCount}</span>
            </p>
          </div>
        </div>
        <div className="customTable__bottom">
          <div className="customTable__buttons d-flex gap-2">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handlePrevious}
              disabled={currentPage <= 1}
            >
              Previous
            </button>
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handleNext}
              disabled={currentPage >= pageCount}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
